import { Box, Divider } from "@mui/material";
import { LoadingBox, hikoGeneratePath } from "@northpowerdev/np-react-utils";
import { useEffect } from "react";
import { useState } from "react";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import useFetchJson from "../../../data/useFetchJson";
import AssetDocsSearchByNumber from "./AssetDocsSearchByNumber";
import AssetDocsShow from "./AssetDocsShow";

// This component is realy similar to AssetDocuments in Mahi.

// const fakeAssetDocs = {
//     assetNumber: 'POLE999999',
//     docs: [
// {
//   "metadata": {
//     "File Name": "trpr14967-20180813_photo1.jpg",
//     "Modified": "14/08/2018 02:28 PM",
//     "Agreement No.": "TRPR14967",
//     "Asset ID": "273608",
//     "Zone": "MANG",
//     "Note Text": "Tree Agreements 12294 & 10426 are also for this Rd / Feeder combination.",
//     "Vicinity": "Cove Road ( over 50 kms areas), Langs Beach",
//     "File Purpose": "PHOT"
//   },
//   "fileName": "trpr14967-20180813_photo1.jpg",
//   "fileKey": "2018/trpr14967-20180813_photo1.jpg",
//   "filePath": "\\\\Waspdocs\\Wasp\\DB\\Whg\\Docs\\AssetManagement\\AssetRegister\\TreeAgreements\\2018\\trpr14967-20180813_photo1.jpg",
//   "fileModified": "2018-08-14T14:28:42+12:00",
//   "contentType": "image/jpeg",
//   "thumbnail": "/bff/tree-agreements-service/api/docs/TRPR14967/get-thumbnail?fileKey=2018/trpr14967-20180813_photo1.jpg&token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI5ODkzMzlkYS1lNjc3LTQzZjItYTVjYS01N2Q2ZWZlYThmNWQiLCJ0b2tlbl90eXBlIjoiYmVhcmVyIiwicm9sZXMiOlsicmVhZCJdLCJpYXQiOjE2ODAxMjkzMDEsImV4cCI6MTY4MDE3MjUwMSwiYXVkIjoibnAtbmV0d29yay1zZXJ2aWNlcy10ZXN0IiwiaXNzIjoibnAtbmV0d29yay1zZXJ2aWNlcy10ZXN0Iiwic3ViIjoiMjAxOC90cnByMTQ5NjctMjAxODA4MTNfcGhvdG8xLmpwZyJ9.Qkvv3i6j3HP5jdD7jUXaT-Mc0o8uqPJw7AJhCQ51A98iHGqqT2lss2Q8GraLMV1eBp5gpr5pkn_q14Yy_T4XHSJKu_-58p4BHjPW0GFs1gS6JwuNvehYcOQd02yCbCVeQWzSjdmTUeyfoEl4kwCK5XIdA3-jSe6N_NhrsUDoqGuMOcpiXFowM7r9EEiIryk-FnCDlNXBAgLjmMfFC6T7IHLZ3dKbUCNYk7igehyv-GnFacN6nTxdeUUVQ7wpJ9_GV_uIaHTHsTm74jo_1Dw0w6ME9j9B-jzG6tSmsrKzIGI2xgoSm9Gzp-7tOEBu71-JBT9cp7s3Qe9P1AvLkZczzg",
//   "url": "/bff/tree-agreements-service/api/docs/TRPR14967/get-document?fileKey=2018/trpr14967-20180813_photo1.jpg&download&token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI5ODkzMzlkYS1lNjc3LTQzZjItYTVjYS01N2Q2ZWZlYThmNWQiLCJ0b2tlbl90eXBlIjoiYmVhcmVyIiwicm9sZXMiOlsicmVhZCJdLCJpYXQiOjE2ODAxMjkzMDEsImV4cCI6MTY4MDE3MjUwMSwiYXVkIjoibnAtbmV0d29yay1zZXJ2aWNlcy10ZXN0IiwiaXNzIjoibnAtbmV0d29yay1zZXJ2aWNlcy10ZXN0Iiwic3ViIjoiMjAxOC90cnByMTQ5NjctMjAxODA4MTNfcGhvdG8xLmpwZyJ9.Qkvv3i6j3HP5jdD7jUXaT-Mc0o8uqPJw7AJhCQ51A98iHGqqT2lss2Q8GraLMV1eBp5gpr5pkn_q14Yy_T4XHSJKu_-58p4BHjPW0GFs1gS6JwuNvehYcOQd02yCbCVeQWzSjdmTUeyfoEl4kwCK5XIdA3-jSe6N_NhrsUDoqGuMOcpiXFowM7r9EEiIryk-FnCDlNXBAgLjmMfFC6T7IHLZ3dKbUCNYk7igehyv-GnFacN6nTxdeUUVQ7wpJ9_GV_uIaHTHsTm74jo_1Dw0w6ME9j9B-jzG6tSmsrKzIGI2xgoSm9Gzp-7tOEBu71-JBT9cp7s3Qe9P1AvLkZczzg",
//   "documentPreview": "/bff/tree-agreements-service/api/docs/TRPR14967/get-document?fileKey=2018/trpr14967-20180813_photo1.jpg&token=eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI5ODkzMzlkYS1lNjc3LTQzZjItYTVjYS01N2Q2ZWZlYThmNWQiLCJ0b2tlbl90eXBlIjoiYmVhcmVyIiwicm9sZXMiOlsicmVhZCJdLCJpYXQiOjE2ODAxMjkzMDEsImV4cCI6MTY4MDE3MjUwMSwiYXVkIjoibnAtbmV0d29yay1zZXJ2aWNlcy10ZXN0IiwiaXNzIjoibnAtbmV0d29yay1zZXJ2aWNlcy10ZXN0Iiwic3ViIjoiMjAxOC90cnByMTQ5NjctMjAxODA4MTNfcGhvdG8xLmpwZyJ9.Qkvv3i6j3HP5jdD7jUXaT-Mc0o8uqPJw7AJhCQ51A98iHGqqT2lss2Q8GraLMV1eBp5gpr5pkn_q14Yy_T4XHSJKu_-58p4BHjPW0GFs1gS6JwuNvehYcOQd02yCbCVeQWzSjdmTUeyfoEl4kwCK5XIdA3-jSe6N_NhrsUDoqGuMOcpiXFowM7r9EEiIryk-FnCDlNXBAgLjmMfFC6T7IHLZ3dKbUCNYk7igehyv-GnFacN6nTxdeUUVQ7wpJ9_GV_uIaHTHsTm74jo_1Dw0w6ME9j9B-jzG6tSmsrKzIGI2xgoSm9Gzp-7tOEBu71-JBT9cp7s3Qe9P1AvLkZczzg"
// }


//     ],
// }

/**
 * 
 * Page-level component that responds to e.g.
 * https://hiko.northpower.com/ni/asset_docs?asset_key=POLE1084471
 * 
 * @returns JSX
 */
export default function AssetDocuments() {

    const [assetKey, setAssetKey] = useState() // Asset key from GET request E.g. POLE1084471
    const location = useLocation()
    const navigate = useNavigate()

    const getAssetDocsPath = '/bff/asset-docs-service/api/docs/get-documents-by-asset-key'
    const {
        isLoading: pageLoading,
        data: assetDocsDetails, // (This example is from Asset Docs in Mahi.) E.g. [{"metadata":{"File Name":"a.jpg","Modified":"14/08/2018 02:28 PM","Agreement No.":"TRPR14967","Asset ID":273608,"Zone":"MANG","Note Text":"nn","Vicinity":"vv","File Purpose":"PHOT"},"fileName":"trpr14967-20180813_photo1.jpg","fileKey":"2018/trpr14967-20180813_photo1.jpg","filePath":"\\\\Waspdocs\\Wasp\\DB\\Whg\\Docs\\AssetManagement\\AssetRegister\\AssetAgreements\\2018\\trpr14967-20180813_photo1.jpg","fileModified":"2018-08-14T14:28:42+12:00","contentType":"image/jpeg","url":"/bff/tree-agreements-service/api/docs/TRPR14967/get-document?fileKey=2018/trpr14967-20180813_photo1.jpg&token=","thumbnail":"/bff/tree-agreements-service/api/docs/TRPR14967/get-thumbnail?fileKey=2018/trpr14967-20180813_photo1.jpg&token="}
        setData: setAssetDocsDetails,
        load: getAssetDocsDetails} = useFetchJson(getAssetDocsPath, {}, false) 

    useEffect(() => {
        if (location.pathname === '/ni/asset_docs') {
            const urlSearch = new URLSearchParams(location.search)
            const theAssetKey = urlSearch.get('asset_key')
            console.log('AssetDocuments entry useEffect theAssetKey', theAssetKey)
            setAssetKey(theAssetKey)
        }
    }, [location]) 

    useEffect(() => {
        console.log('AssetDocuments useEffect assetKey', assetKey)
        if (!assetKey) {
            return
        }
        const assetDocsParams = {
            params: {assetKey}
        }
        getAssetDocsDetails(assetDocsParams, getAssetDocsPath) // run in background 

    }, [assetKey, getAssetDocsDetails, setAssetDocsDetails])

    const handleFindAssetDocs = (assetNumber) => {
        console.log('handleFindAssetDocs', assetNumber)
        const urlString = '/ni/asset_docs'
        const params = {asset_key: assetNumber}
        // const path = generatePath(":urlString?:queryString", { urlString, queryString: createSearchParams(params).toString() });
        const path = hikoGeneratePath(urlString, createSearchParams(params).toString())
        navigate(path)
    }

    return (
        <Box>
            <h2 className="np-title" style={{marginBottom: 0}}>Asset Documents</h2>

            <AssetDocsSearchByNumber sx={{mb: 2}} defaultValue={assetKey} findDocs={handleFindAssetDocs} pageLoading={pageLoading} />
            <Divider sx={{my: 2}}/>
            <LoadingBox loading={pageLoading}>
            {
                assetDocsDetails
                &&
                <AssetDocsShow assetKey={assetKey} assetDocsDetails={assetDocsDetails} />
            }
            </LoadingBox>
        </Box>
    )
}
